// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Success toast after password update (long copy + redirect to login) */
.Toastify__toast.toast-password-update-success {
  max-width: min(520px, 94vw);
  width: 100%;
  min-height: auto;
  padding: 14px 16px;
}

.Toastify__toast.toast-password-update-success .Toastify__toast-body {
  padding: 0;
  margin: 0;
  width: 100%;
}

.password-update-toast-inner {
  text-align: left;
  line-height: 1.45;
}

.password-update-toast-primary {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: inherit;
}

.password-update-toast-secondary {
  margin: 8px 0 0;
  font-size: 13px;
  font-weight: 400;
  opacity: 0.95;
  color: inherit;
}
`, "",{"version":3,"sources":["webpack://./src/components/dashboardcomponents/Settings/securityToast.css"],"names":[],"mappings":"AAAA,wEAAwE;AACxE;EACE,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,cAAc;AAChB","sourcesContent":["/* Success toast after password update (long copy + redirect to login) */\n.Toastify__toast.toast-password-update-success {\n  max-width: min(520px, 94vw);\n  width: 100%;\n  min-height: auto;\n  padding: 14px 16px;\n}\n\n.Toastify__toast.toast-password-update-success .Toastify__toast-body {\n  padding: 0;\n  margin: 0;\n  width: 100%;\n}\n\n.password-update-toast-inner {\n  text-align: left;\n  line-height: 1.45;\n}\n\n.password-update-toast-primary {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: inherit;\n}\n\n.password-update-toast-secondary {\n  margin: 8px 0 0;\n  font-size: 13px;\n  font-weight: 400;\n  opacity: 0.95;\n  color: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
